import { FC } from 'react'

import CONFIG from '../../../config'
import { AuthRoles } from '../../models'

type BackgroundProps = {
  role?: AuthRoles
}

const Background:FC<BackgroundProps> = ({ role = '' }) => <div className={`col-12 lg:col-6 ${role === CONFIG.AUTH.ROLES.ADMIN ? 'home-admin-bg' : 'home-bg'}`} />

export { Background }